import {AVATAR_COLORS} from 'ff-common';

export default {
  black: {
    pure: '#0000',
    ff: '#191B20',
    text: '#202125',
    transparent: '#00000020',
    transparency_40: '#00000066',
    transparency_88: '#000000E0',
    shadow_transparency_5: '#1018280D',
  },
  white: {
    50: '#FFFFFF80',
    100: '#FFFFFF',
    transparency_10: '#FFFFFF1A',
    transparency_20: '#FFFFFF33',
    transparency_30: '#FFFFFF4D',
  },
  yellow: {
    50: '#FAF3E6',
    100: '#FCEC4D',
    500: '#C6B403',
    sun: '#F2DE00',
    warning: '#FCF3E1',
    warning_text: '#C80',
    selected_bg: '#FDF4E1',
    selected_text: '#CC8801',
  },
  red: {
    100: '#BF453C',
    200: '#D54A3B',
    fail: '#E4191B',
    fail_bg: '#E4191B0D',
    fail_50: '#FFD3D3',
    fail_transparency_10: '#E4191B1A',
    warning: '#E10909',
    warning_bg: '#FFE6E6',
    promo_bg: '#FCE8E8',
    promo_border: '#F39596',
    assistance: '#C02952',
    assistance_bg: '#FCEFF6',
    assistance_prix: '#90042A',
  },
  blue: {
    50: '#3249C4',
    100: '#18235E', // default
    200: '#BEDEED',
    bg: '#E6F1F9',
    bg_light: '#EEF5FA',
    main_light: '#DAE8FF',
    main_light_bg: '#E6EEF8',
    main: '#0057B8',
    500: '#0072BA',
    transparency_10: '#0026881A',
    transparency_20: '#00268833',
    main_transparency_5: '#0072BA0D',
    main_transparency_10: '#0072BA1A',
    main_transparency_30: '#0072BA4D',
    main_transparency_60: '#0057B899',
    dark: '#004EA5',
    deep: '#003065',
    navy: '#00254D',
    bo_menu: '#08203B',
    sky: '#2AAAFB',
    sky_light: '#E1F3FF',
    text: '#242733',
    border: '#B0CBE9',
    border_dark: '#8AB2DE',
  },
  lblue: {
    50: '#E3F5FF',
    100: '#E6F1F9',
    150: '#E6F0F7',
    200: '#EDF1FB',
    300: '#DDEBF5',
    transparency_300_60: '#DDEBF599',
  },
  gray: {
    50: '#F8F8F8',
    75: '#F9F9FA',
    100: '#F3F3F3',
    150: '#EEEFF2',
    200: '#ECECEC',
    400: '#DCDCDC',
    500: '#8E92A5',
    600: '#B1B1B1',
    800: '#6D6C6C',
    900: '#1B1919',
    bg: '#F7F7F7',
    lighter: '#F2F2F4',
    light: '#EBECEE', // default
    light_bg: '#F6F6F7',
    extra_light: '#F9FAFA',
    dark: '#565D79',
    dark_transparency_10: '#565D791A',
    placeholder: '#9CA3AF', // icônes et textes d'attente, ex. zone de dépôt vide
    medium: '#787D94',
    text_secondary: '#667085',
    pill_bg: '#F4F6F9', // pastille client de l'accueil
    card: '#F5F6F8', // cartes d'action de l'accueil, forme ligne
    card_warm: '#F8F8F5', // cartes d'action de l'accueil, forme colonne
  },
  green: {
    success: '#2AA948',
    success_bg: '#4CAC0014',
    success_50: '#EAF6ED',
    pastel_bg: '#E8F3EA',
    success_transparency_10: '#2AA9481A',
    connecte: '#219653',
    connecte_transparency_10: '#2196531A',
    egalim: '#4CAC00',
    egalim_bg: '#4CAC0014',
    prix_metier: '#1E7833',
    hover_prix_metier: '#dbf8c3',
  },
  // Couleurs d'avatar - palette partagee depuis ff-common
  avatar: {
    purple: AVATAR_COLORS[0],
    green: AVATAR_COLORS[1],
    yellow: AVATAR_COLORS[2],
    blue_gray: AVATAR_COLORS[3],
    pink: AVATAR_COLORS[4],
    cyan: AVATAR_COLORS[5],
    orange: AVATAR_COLORS[6],
    teal: AVATAR_COLORS[7],
  },
  cyan: {
    surgele: '#6DDBDB',
    surgele_bg: '#6DDADA1A',
    surgele_border: '#6DDADA',
  },
  transparent: {
    0: '#FFF0',
    10: '#FFF2',
    50: '#FFF8',
  },
  orange: {
    warning: '#CC8800',
    warning_50: '#FAF3E6',
    warning_transparency_10: '#CC88001A',
    fail: '#ff9f00',
  },
  categories: {
    produits_laitiers: '#BEDEED',
    frais: '#F6C7BD',
    surgeles: '#252E88',
    epicerie: '#F6CAA1',
    boissons: '#9D8776',
    maree_fraiche: '#4D9AD9',
    fruits_et_legumes: '#82BA75',
    non_alimentaire: '#F5F1F5',
  },
  // Palette proposée au backoffice pour la couleur du bandeau d'une opération commerciale,
  // dans l'ordre d'affichage des pastilles. C'est la valeur hex qui est enregistrée en base.
  banniere_operation_commerciale: {
    rouge: '#FF4545',
    orange: '#FF8C00',
    jaune: '#FFD600',
    vert: '#33C759',
    turquoise: '#21B2AB',
    bleu: '#4273F2',
    violet: '#8A2BE3',
    rose: '#FF69B5',
    framboise: '#F04573',
    emeraude: '#00BF8C',
    corail: '#FA7324',
    azur: '#4A8FE3',
  },
};
